/**
 * 认证 API — 登录 / 刷新 Token。
 */
import client from "./client";
import type { LoginResponse } from "../types";

/** 登录请求参数。 */
interface LoginParams {
  email: string;
  password: string;
}

/**
 * 用户登录。
 * POST /api/auth/login → {access_token, refresh_token, account}
 */
export async function login(params: LoginParams): Promise<LoginResponse> {
  return client.post<unknown, LoginResponse>("/auth/login", params);
}

/**
 * 刷新 Access Token。
 * POST /api/auth/refresh → {access_token}
 */
export async function refreshToken(refreshToken: string): Promise<string> {
  const data = await client.post<unknown, { access_token: string }>(
    "/auth/refresh",
    { refresh_token: refreshToken },
  );
  return data.access_token;
}
